(function() { window.GUID_20ff3e60_7e44_4819_9197_d00d81fe27b0 = { getGuid: function() { return "20ff3e60-7e44-4819-9197-d00d81fe27b0"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class RotateYourPhone extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnBindEvents() { }
            OnDispose() { }
            OnControlRendered() {
                const popup = Controls.GetInstance(Controls.Popup, this.$Control.closest(".popup.control-cs"), true);
                const $illustration = this.$Control.find(".prompt-illustration");
                if ($illustration.length) {
                    setTimeout(() => {
                        $illustration.css({
                            transform: "rotate(-90deg)",
                            transition: "transform 1.5s ease-in-out",
                        });
                    }, 1000);
                }
                this.$Control.offon("click.buttonwithinwasclicked", "#button-rotate-your-phone-prompt", (e) => {
                    if (popup) {
                        popup.Close();
                    }
                });
                CS.Lag("RotateYourPhonePromptPopup", 8000, () => {
                    if (popup) {
                        popup.Close();
                    }
                });
            }
        }
        Controls.RotateYourPhone = RotateYourPhone;
        (function (RotateYourPhone) {
            class Events {
            }
            RotateYourPhone.Events = Events;
            class EventNames {
            }
            RotateYourPhone.EventNames = EventNames;
        })(RotateYourPhone = Controls.RotateYourPhone || (Controls.RotateYourPhone = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=rotate-your-phone.js.map
